import { ResolveFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { finalize, map } from 'rxjs';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';
import { UsuarioService } from '../../shared/services/usuario.service';
import { LoadingService } from '../../shared/services/loading.service';

// Provê { usuario } em route.data.data para que step-1 possa inicializar seu formulário
const edicaoDadosResolver: ResolveFn<any> = () => {
  const usuarioService = inject(UsuarioService);
  const loadingService = inject(LoadingService);
  loadingService.open();
  return usuarioService.current().pipe(
    map((usuario) => ({ usuario })),
    finalize(() => loadingService.close()),
  );
};

export const minhaInscricaoRoutes: Routes = [
  {
    path: 'minha-inscricao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Minha Inscrição',
      roles: [Role.ROLE_INSCRICAO_VISUALIZAR],
      breadcrumb: [{ label: 'Minha Inscrição' }],
    },
    children: [
      {
        path: 'analise-documental/inserir-documentos',
        loadComponent: () =>
          import('./inserir-documentos/inserir-documentos.component').then(
            (m) => m.InserirDocumentosComponent,
          ),
        data: {
          title: 'Inserir Documentos',
          roles: [Role.INSERIR_DOCUMENTACAO_CONSULTAR, Role.INSERIR_DOCUMENTACAO_CADASTRAR],
          breadcrumb: [
            { label: 'Inserir Documentos', url: '/minha-inscricao/analise-documental/inserir-documentos' },
          ],
        },
      },
      {
        path: 'analise-documental/finalizacao',
        loadComponent: () =>
          import('./finalizacao-envio/finalizacao-envio.component').then(
            (m) => m.FinalizacaoEnvioComponent,
          ),
        data: {
          title: 'Inserir Documentos',
          roles: [Role.INSERIR_DOCUMENTACAO_CONSULTAR, Role.INSERIR_DOCUMENTACAO_CADASTRAR],
          breadcrumb: [
            { label: 'Inserir Documentos', url: '/minha-inscricao/analise-documental/finalizacao' },
          ],
        },
      },
      {
        path: 'atualizacao-dados',
        loadComponent: () =>
          import('./edicao-dados-inscricao/edicao-dados-inscricao.component').then(
            (m) => m.EdicaoDadosInscricaoComponent,
          ),
        resolve: { data: edicaoDadosResolver },
        data: {
          title: 'Atualização de Dados',
          roles: [Role.ROLE_ATUALIZAR_DADOS_INSCRICAO],
          breadcrumb: [
            { label: 'Atualização de Dados', url: '/minha-inscricao/atualizacao-dados' },
          ],
        },
      },
      {
        path: 'analise-documental/comprovante',
        loadComponent: () =>
          import('./comprovante-envio/comprovante-envio.component').then(
            (m) => m.ComprovanteEnvioComponent,
          ),
        data: {
          title: 'Inserir Documentos',
          roles: [Role.INSERIR_DOCUMENTACAO_CONSULTAR, Role.INSERIR_DOCUMENTACAO_CADASTRAR],
          breadcrumb: [
            { label: 'Inserir Documentos', url: '/minha-inscricao/analise-documental/comprovante' },
          ],
        },
      },
    ],
  },
];
